import { render, staticRenderFns } from "./QGratitudesJournalNotices.vue?vue&type=template&id=07c074c4&"
import script from "./QGratitudesJournalNotices.vue?vue&type=script&lang=js&"
export * from "./QGratitudesJournalNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports